document.addEventListener('DOMContentLoaded', function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    let lastScrollY = window.scrollY;
    let ticking = false;

    function setBodyPadding() {
        requestAnimationFrame(() => {
            const rect = headerWrapper.getBoundingClientRect();
            const headerHeight = rect.height;
            if (headerHeight > 0) {
                document.body.style.paddingTop = headerHeight + 'px';
            }
        });
    }

    setBodyPadding();
    window.addEventListener('resize', setBodyPadding);

    function updateHeader() {
        const currentScrollY = window.scrollY;

        if (currentScrollY > 10) {
            headerWrapper.classList.add('scrolled');
        } else {
            headerWrapper.classList.remove('scrolled');
        }

        if (currentScrollY > 100) {
            if (currentScrollY > lastScrollY && currentScrollY > 300) {
                headerWrapper.style.transform = 'translateY(calc(-100% - 18px))';
                headerWrapper.classList.add('hide');
            } else if (currentScrollY < lastScrollY) {
                headerWrapper.style.transform = 'translateY(0)';
                headerWrapper.classList.remove('hide');
            }
        } else {
            headerWrapper.style.transform = 'translateY(0)';
            headerWrapper.classList.remove('hide');
        }

        lastScrollY = currentScrollY;
        ticking = false;
    }

    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(updateHeader);
            ticking = true;
        }
    });

    const searchToggle = document.querySelector('.header-search-toggle');
    const searchArea = document.querySelector('.header-search');
    const searchInput = document.querySelector('#header-search-input');

    if (searchToggle && searchArea) {
        searchToggle.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
            searchArea.setAttribute('aria-hidden', isExpanded);

            if (!isExpanded) {
                searchInput.focus();
            }
        });

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && searchArea.getAttribute('aria-hidden') === 'false') {
                searchToggle.setAttribute('aria-expanded', 'false');
                searchArea.setAttribute('aria-hidden', 'true');
                searchToggle.focus();
            }
        });
    }

    // Language Toggle - Enhanced with proper dropdown class toggle
    const languageToggle = document.querySelector('.header-language-toggle');
    const languageDropdown = document.querySelector('.header-language-dropdown');

    if (languageToggle && languageDropdown) {
        languageToggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
            // Add class toggle for CSS visibility
            languageDropdown.classList.toggle('is-open', !isExpanded);
        });

        // Handle language switch links
        const languageOptions = languageDropdown.querySelectorAll('.header-language-option');
        languageOptions.forEach(option => {
            option.addEventListener('click', function(e) {
                // Optional: Add loading state
                document.body.style.opacity = '0.7';
                document.body.style.transition = 'opacity 0.3s';
            });
        });
    }

    // Mobile Language Switch - Enhanced
    const mobileLangToggle = document.querySelector('#mobile-navigation .mobile-submenu-toggle[aria-controls="mobile-submenu-language"]');
    const mobileLangSubmenu = document.querySelector('#mobile-submenu-language');

    if (mobileLangToggle && mobileLangSubmenu) {
        // Override the general mobile submenu toggle for language specifically
        mobileLangToggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
            mobileLangSubmenu.setAttribute('aria-hidden', isExpanded);
            mobileLangSubmenu.classList.toggle('is-open', !isExpanded);
        });

        // Handle mobile language switch links
        const mobileLangOptions = mobileLangSubmenu.querySelectorAll('.mobile-submenu-link');
        mobileLangOptions.forEach(option => {
            option.addEventListener('click', function(e) {
                // Optional: Add loading state
                document.body.style.opacity = '0.7';
                document.body.style.transition = 'opacity 0.3s';
            });
        });
    }

    const dropdownToggles = document.querySelectorAll('.header-nav-dropdown-toggle');
    dropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            dropdownToggles.forEach(t => {
                if (t !== this) {
                    t.setAttribute('aria-expanded', 'false');
                }
            });

            if (isExpanded) {
                const dropdown = this.nextElementSibling;
                if (dropdown) {
                    const subdropdownToggles = dropdown.querySelectorAll('.header-subdropdown-toggle');
                    subdropdownToggles.forEach(subToggle => {
                        subToggle.setAttribute('aria-expanded', 'false');
                    });
                }
            }

            this.setAttribute('aria-expanded', !isExpanded);
        });
    });

    const subdropdownToggles = document.querySelectorAll('.header-subdropdown-toggle');
    subdropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            const parentDropdown = this.closest('.header-dropdown');
            if (parentDropdown) {
                const siblingToggles = parentDropdown.querySelectorAll('.header-subdropdown-toggle');
                siblingToggles.forEach(t => {
                    if (t !== this) {
                        t.setAttribute('aria-expanded', 'false');
                    }
                });
            }

            this.setAttribute('aria-expanded', !isExpanded);
        });
    });

    const mobileMenuToggle = document.querySelector('.header-mobile-menu-toggle');
    const mobileMenuClose = document.querySelector('.mobile-navigation-close');
    const mobileNav = document.querySelector('.mobile-navigation');

    if (mobileMenuToggle && mobileNav) {
        mobileMenuToggle.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
            mobileNav.setAttribute('aria-hidden', isExpanded);
            document.body.classList.toggle('mobile-menu-open');
        });

        if (mobileMenuClose) {
            mobileMenuClose.addEventListener('click', function() {
                mobileMenuToggle.setAttribute('aria-expanded', 'false');
                mobileNav.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('mobile-menu-open');
            });
        }
    }

    const mobileSubmenuToggles = document.querySelectorAll('.mobile-submenu-toggle');
    mobileSubmenuToggles.forEach(toggle => {
        // Skip language toggle as it's handled separately
        if (!toggle.getAttribute('aria-controls')?.includes('language')) {
            toggle.addEventListener('click', function() {
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                const submenu = this.nextElementSibling;

                this.setAttribute('aria-expanded', !isExpanded);
                if (submenu) {
                    submenu.setAttribute('aria-hidden', isExpanded);
                }
            });
        }
    });

    const mobileSubsubmenuToggles = document.querySelectorAll('.mobile-subsubmenu-toggle');
    mobileSubsubmenuToggles.forEach(toggle => {
        toggle.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const subsubmenu = this.nextElementSibling;

            this.setAttribute('aria-expanded', !isExpanded);
            if (subsubmenu) {
                subsubmenu.setAttribute('aria-hidden', isExpanded);
            }
        });
    });

    document.addEventListener('click', function(e) {
        if (!e.target.closest('.header-nav-item')) {
            dropdownToggles.forEach(toggle => {
                toggle.setAttribute('aria-expanded', 'false');
            });
            subdropdownToggles.forEach(toggle => {
                toggle.setAttribute('aria-expanded', 'false');
            });
        }

        // Close language dropdown when clicking outside
        if (!e.target.closest('.header-language-switch')) {
            if (languageToggle) {
                languageToggle.setAttribute('aria-expanded', 'false');
                // Also remove the is-open class
                languageDropdown?.classList.remove('is-open');
            }
        }

        if (!e.target.closest('.header-search') && !e.target.closest('.header-search-toggle')) {
            if (searchToggle && searchArea) {
                searchToggle.setAttribute('aria-expanded', 'false');
                searchArea.setAttribute('aria-hidden', 'true');
            }
        }
    });

    // Escape key handler for language dropdown
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            if (languageToggle && languageToggle.getAttribute('aria-expanded') === 'true') {
                languageToggle.setAttribute('aria-expanded', 'false');
                languageDropdown?.classList.remove('is-open');
                languageToggle.focus();
            }
        }
    });

    const dropdownLinks = document.querySelectorAll('.header-dropdown a, .header-subdropdown a');
    dropdownLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.stopPropagation();
        });
    });

    // Footer Language Switch - Updated with Mobile Accordion Support
    const footerLangToggle = document.querySelector('.footer-language-toggle');
    const footerLangDropdown = document.querySelector('.footer-language-dropdown');

    if (footerLangToggle && footerLangDropdown) {
        footerLangToggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            const newState = !isExpanded;

            // Update aria-expanded attribute
            this.setAttribute('aria-expanded', newState);

            // Update dropdown visibility based on screen size
            if (window.innerWidth < 768) {
                // Mobile accordion behavior
                footerLangDropdown.setAttribute('aria-hidden', !newState);
            } else {
                // Desktop dropdown behavior is handled by CSS
                footerLangDropdown.setAttribute('aria-hidden', !newState);
            }
        });

        // Close dropdown when clicking outside (for desktop)
        document.addEventListener('click', function(e) {
            if (window.innerWidth >= 768) { // Only for desktop
                if (!footerLangToggle.contains(e.target) && !footerLangDropdown.contains(e.target)) {
                    footerLangToggle.setAttribute('aria-expanded', 'false');
                    footerLangDropdown.setAttribute('aria-hidden', 'true');
                }
            }
        });

        // Handle window resize to ensure proper behavior switching
        window.addEventListener('resize', function() {
            const isExpanded = footerLangToggle.getAttribute('aria-expanded') === 'true';

            if (window.innerWidth < 768) {
                // Mobile: use aria-hidden for accordion
                footerLangDropdown.setAttribute('aria-hidden', !isExpanded);
            } else {
                // Desktop: CSS handles visibility, but keep aria-hidden in sync
                footerLangDropdown.setAttribute('aria-hidden', !isExpanded);
            }
        });

        // Handle keyboard navigation
        footerLangToggle.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            } else if (e.key === 'Escape') {
                this.setAttribute('aria-expanded', 'false');
                footerLangDropdown.setAttribute('aria-hidden', 'true');
                this.focus();
            }
        });

        // Handle arrow key navigation within dropdown
        footerLangDropdown.addEventListener('keydown', function(e) {
            const languageOptions = this.querySelectorAll('.footer-language-option');
            const currentIndex = Array.from(languageOptions).findIndex(option => option === document.activeElement);

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const nextIndex = (currentIndex + 1) % languageOptions.length;
                languageOptions[nextIndex].focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prevIndex = currentIndex <= 0 ? languageOptions.length - 1 : currentIndex - 1;
                languageOptions[prevIndex].focus();
            } else if (e.key === 'Escape') {
                e.preventDefault();
                footerLangToggle.setAttribute('aria-expanded', 'false');
                footerLangDropdown.setAttribute('aria-hidden', 'true');
                footerLangToggle.focus();
            }
        });

        // Handle footer language switch links
        const footerLangOptions = footerLangDropdown.querySelectorAll('.footer-language-option');
        footerLangOptions.forEach(option => {
            option.addEventListener('click', function(e) {
                // Optional: Add loading state
                document.body.style.opacity = '0.7';
                document.body.style.transition = 'opacity 0.3s';
            });
        });
    }

    // Helper function to handle language switching (optional)
    function switchLanguage(locale) {
        const currentPath = window.location.pathname;
        let newPath;

        if (locale === 'en') {
            // Switch to English
            if (!currentPath.startsWith('/en')) {
                newPath = '/en' + currentPath;
            }
        } else {
            // Switch to German (default)
            newPath = currentPath.replace(/^\/en/, '');
            if (newPath === '') newPath = '/';
        }

        // Add loading indicator
        document.body.style.opacity = '0.5';
        document.body.style.transition = 'opacity 0.3s';

        // Navigate to new path
        window.location.href = newPath;
    }

    // Expose switchLanguage function globally if needed
    window.switchLanguage = switchLanguage;
});